import { getPathFromUrl } from '@/helpers/url.js'

export function getProductsInProductImpressionFormat(products, hardcodedList) {
  const list = hardcodedList || getPathFromUrl(window.location.href.split('?')[0])
  return products.reduce((data, card, index) => {
    const mainVariant = card.variants.filter(v => v.id == card.mainVariantId)[0] || card.variants[0]

    if (mainVariant) {
      data.push({
        id: mainVariant.spreeProduct?.sku || mainVariant.skus.sku,
        price: card.price,
        list,
        position: index + 1,
      })
    }
    return data
  }, [])
}
